import socket from '@drivesally/sally-fw/lib/sockets/wrapper.socket';

export default socket('crm-ticket-closed');
